




















import { MultiResourceMixin } from '@/mixins/multiResourceMixin'
import { DarkModePickerElInterface } from '@/config/interfaces'
import Utils from '@/helpers/Utils'

const HEADER_DARK_MODE = process.env.VUE_APP_HEADER_DARK_MODE

export default MultiResourceMixin.extend({
  name: 'DarkModePickerEl',

  data: () => ({
    selectedTheme: localStorage.getItem('theme') ?? 'light'
  }),

  methods: {
    update (): void {
      localStorage.setItem('theme', this.selectedTheme)

      this.$axios.defaults.headers.common[HEADER_DARK_MODE] = this.selectedTheme === 'system'
        ? window.matchMedia('(prefers-color-scheme: dark)').matches
        : this.selectedTheme === 'dark'

      Utils.reloadPage(this.$router)
    }
  },

  props: {
    templateItemData: {
      type: Object as () => DarkModePickerElInterface,
      required: true
    }
  },

  computed: {
    options (): Array<Record<string, string>> {
      return [
        { text: 'Svetla tema', value: 'light' },
        { text: 'Tamna tema', value: 'dark' },
        { text: 'Sistemska tema', value: 'system' }
      ]
    }
  }
})
